import {Component} from '@angular/core';
import {NAV_ITEMS} from '../../../nav-items';

/**
 * Bottom navigation for phones (hidden from md up, where the top bar shows the links).
 */
@Component({
  selector: 'app-tab-bar',
  template: `
    <nav class="tab-bar" aria-label="Main">
      <a *ngFor="let item of items"
         [routerLink]="item.route"
         routerLinkActive="active"
         #rla="routerLinkActive"
         [routerLinkActiveOptions]="{exact: item.exact}"
         [attr.aria-current]="rla.isActive ? 'page' : null">
        <i class="bi" [ngClass]="rla.isActive ? item.iconActive : item.icon"></i>
        <span>{{ item.short }}</span>
      </a>
    </nav>
  `,
  styles: [`
    .tab-bar {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1030;
      display: flex;
      height: calc(var(--tabbar-h) + var(--safe-bottom));
      padding-bottom: var(--safe-bottom);
      background: rgba(255, 255, 255, 0.96);
      backdrop-filter: saturate(180%) blur(12px);
      -webkit-backdrop-filter: saturate(180%) blur(12px);
      border-top: 1px solid var(--line);
    }
    a {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 2px;
      color: var(--faint);
      text-decoration: none;
      font-size: 0.7rem;
      font-weight: 500;
    }
    a i {
      font-size: 1.3rem;
      line-height: 1;
    }
    a.active {
      color: var(--brand-dark);
      font-weight: 700;
    }
    @media (min-width: 768px) {
      .tab-bar { display: none; }
    }
  `],
  standalone: false
})
export class TabBarComponent {
  items = NAV_ITEMS;
}
